import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';

export default function TicketSearch() {
  const { tenant } = useAuth();
  const primary = tenant?.branding?.primary_color || '#1B6B3A';
  const [searchType, setSearchType] = useState('customer');
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedTech, setSelectedTech] = useState('');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [staffUsers, setStaffUsers] = useState([]);
  const [searched, setSearched] = useState(false);

  useEffect(()=>{
    api.get('/users/technicians').then(r=>{
      setStaffUsers(r.data?.technicians||[]);
    }).catch(()=>{});
  },[]);

  const doSearch = async () => {
    if(!searchQuery.trim() && !selectedTech) return;
    setLoading(true); setResults([]); setSearched(true);
    try {
      const params = {limit:100};
      if(searchType==='customer') params.search = searchQuery.trim();
      else params.created_by = selectedTech;
      const r = await api.get('/tickets', {params});
      setResults(r.data.tickets||[]);
    } catch(e){}
    setLoading(false);
  };

  const statusColor = s => s==='resolved'?{bg:'#dcfce7',c:'#16a34a'}:s==='open'?{bg:'#fef3c7',c:'#d97706'}:{bg:'#eff6ff',c:'#2563eb'};
  const priorityColor = p => p==='critical'?{bg:'#fee2e2',c:'#dc2626'}:p==='high'?{bg:'#fef3c7',c:'#d97706'}:{bg:'#f0fdf4',c:'#16a34a'};

  return (
    <div style={{padding:'20px',maxWidth:'1100px',margin:'0 auto'}}>
      <div style={{marginBottom:'20px'}}>
        <h2 style={{fontSize:'20px',fontWeight:'800',color:'#0f172a',margin:0}}>🔍 Ticket Search</h2>
        <p style={{color:'#64748b',fontSize:'13px',marginTop:'4px'}}>Search tickets by customer or technician</p>
      </div>

      {/* Search Type */}
      <div style={{background:'white',borderRadius:'12px',padding:'20px',boxShadow:'0 1px 4px rgba(0,0,0,0.06)',marginBottom:'16px'}}>
        <div style={{display:'flex',gap:'8px',marginBottom:'16px'}}>
          {[['customer','👤 By Customer'],['tech','🔧 By Technician']].map(([t,l])=>(
            <button key={t} onClick={()=>{setSearchType(t);setResults([]);setSearched(false);}}
              style={{padding:'8px 18px',border:'none',borderRadius:'8px',cursor:'pointer',fontWeight:'700',fontSize:'13px',
                background:searchType===t?primary:'#f1f5f9',color:searchType===t?'white':'#64748b'}}>
              {l}
            </button>
          ))}
        </div>

        {searchType==='customer' ? (
          <div style={{display:'flex',gap:'8px'}}>
            <input value={searchQuery} onChange={e=>setSearchQuery(e.target.value)}
              onKeyDown={e=>e.key==='Enter'&&doSearch()}
              placeholder="Enter username, name, phone number or connection ID..."
              style={{flex:1,padding:'10px 14px',border:'1.5px solid #e2e8f0',borderRadius:'8px',fontSize:'13px',outline:'none'}}/>
            <button onClick={doSearch}
              style={{padding:'10px 24px',background:primary,color:'white',border:'none',borderRadius:'8px',cursor:'pointer',fontWeight:'700',fontSize:'13px'}}>
              🔍 Search
            </button>
          </div>
        ) : (
          <div style={{display:'flex',gap:'8px'}}>
            <select value={selectedTech} onChange={e=>setSelectedTech(e.target.value)}
              style={{flex:1,padding:'10px 14px',border:'1.5px solid #e2e8f0',borderRadius:'8px',fontSize:'13px',outline:'none'}}>
              <option value="">Select Technician/Staff...</option>
              {staffUsers.map(u=>(
                <option key={u._id} value={u._id}>{u.name} — {u.role}</option>
              ))}
            </select>
            <button onClick={doSearch}
              style={{padding:'10px 24px',background:primary,color:'white',border:'none',borderRadius:'8px',cursor:'pointer',fontWeight:'700',fontSize:'13px'}}>
              🔍 Search
            </button>
          </div>
        )}
      </div>

      {/* Results */}
      {loading && <div style={{textAlign:'center',padding:'60px',color:'#94a3b8',fontSize:'14px'}}>Searching...</div>}

      {!loading && searched && results.length===0 && (
        <div style={{textAlign:'center',padding:'60px',color:'#94a3b8',fontSize:'14px'}}>No tickets found</div>
      )}

      {!loading && results.length>0 && (
        <div style={{background:'white',borderRadius:'12px',overflow:'hidden',boxShadow:'0 1px 4px rgba(0,0,0,0.06)'}}>
          <div style={{padding:'14px 20px',borderBottom:'1px solid #f1f5f9',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
            <span style={{fontWeight:'700',fontSize:'14px',color:'#0f172a'}}>Found {results.length} tickets</span>
          </div>
          <div style={{overflowX:'auto'}}>
            <table style={{width:'100%',borderCollapse:'collapse'}}>
              <thead>
                <tr style={{background:'#f8fafc'}}>
                  {['Ticket#','Customer','Connection ID','Category','Status','Priority','Date','Assigned To'].map(h=>(
                    <th key={h} style={{padding:'10px 14px',textAlign:'left',fontSize:'11px',color:'#64748b',fontWeight:'700',whiteSpace:'nowrap'}}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {results.map((t,i)=>{
                  const sc = statusColor(t.status);
                  const pc = priorityColor(t.complaint?.priority);
                  return (
                    <tr key={t._id} style={{background:i%2?'#f9fafb':'white',cursor:'pointer'}}
                      onClick={()=>window.open('/tickets/'+t._id,'_blank')}>
                      <td style={{padding:'10px 14px',fontSize:'13px',fontWeight:'800',color:primary}}>
                        #{t.ticket_number||t._id.slice(-6)}
                      </td>
                      <td style={{padding:'10px 14px'}}>
                        <div style={{fontWeight:'600',fontSize:'13px'}}>{t.customer?.name||'—'}</div>
                        <div style={{fontSize:'11px',color:'#94a3b8'}}>{t.customer?.phone||''}</div>
                      </td>
                      <td style={{padding:'10px 14px',fontSize:'12px',color:'#475569'}}>{t.customer?.connection_id||'—'}</td>
                      <td style={{padding:'10px 14px',fontSize:'12px'}}>{t.complaint?.category||'—'}</td>
                      <td style={{padding:'10px 14px'}}>
                        <span style={{padding:'3px 10px',borderRadius:'20px',fontSize:'11px',fontWeight:'700',
                          background:sc.bg,color:sc.c}}>{t.status}</span>
                      </td>
                      <td style={{padding:'10px 14px'}}>
                        <span style={{padding:'3px 10px',borderRadius:'20px',fontSize:'11px',fontWeight:'700',
                          background:pc.bg,color:pc.c}}>{t.complaint?.priority||'normal'}</span>
                      </td>
                      <td style={{padding:'10px 14px',fontSize:'11px',color:'#64748b',whiteSpace:'nowrap'}}>
                        {t.createdAt?new Date(t.createdAt).toLocaleDateString('en-IN',{day:'2-digit',month:'short',year:'numeric'}):'—'}
                      </td>
                      <td style={{padding:'10px 14px',fontSize:'12px',color:'#475569'}}>{t.assigned_to?.name||'—'}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
